var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdateIcon = function SvgUpdateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#578A1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.625,
    d: "M21 38.5c9.665 0 17.5-7.835 17.5-17.5S30.665 3.5 21 3.5 3.5 11.335 3.5 21 11.335 38.5 21 38.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#578A1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.625,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.017 25.396c.315.525.7 1.015 1.138 1.452 3.22 3.22 8.452 3.22 11.69 0 1.312-1.312 2.065-2.975 2.31-4.672M12.845 19.83c.245-1.715.997-3.36 2.31-4.673 3.22-3.22 8.452-3.22 11.69 0a7.98 7.98 0 0 1 1.137 1.453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.685 30.07v-4.672h4.672M28.315 11.938v4.672h-4.673"
  }))));
};
export default SvgUpdateIcon;